type WatchLoaderProps = {
  label?: string
  size?: 'sm' | 'md'
  variant?: 'light' | 'dark'
  className?: string
}

export function WatchLoader({
  label,
  size = 'sm',
  variant = 'light',
  className = '',
}: WatchLoaderProps) {
  return (
    <div
      className={`watch-loader watch-loader-${size} watch-loader-${variant} ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-label={label ?? 'Loading'}
    >
      <div className="watch-loader-face" aria-hidden="true">
        <svg viewBox="0 0 100 100" className="watch-loader-svg">
          <circle cx="50" cy="50" r="46" className="watch-loader-bezel" />
          <circle cx="50" cy="50" r="40" className="watch-loader-dial" />
          {Array.from({ length: 12 }, (_, i) => {
            const angle = (i * 30 * Math.PI) / 180
            const x1 = 50 + Math.sin(angle) * 34
            const y1 = 50 - Math.cos(angle) * 34
            const x2 = 50 + Math.sin(angle) * 38
            const y2 = 50 - Math.cos(angle) * 38
            return (
              <line
                key={i}
                x1={x1}
                y1={y1}
                x2={x2}
                y2={y2}
                className="watch-loader-tick"
              />
            )
          })}
          <rect x="88" y="44" width="6" height="12" rx="2" className="watch-loader-crown" />
        </svg>
        <div className="watch-loader-hands">
          <span className="watch-hand watch-hand-hour" />
          <span className="watch-hand watch-hand-minute" />
          <span className="watch-hand watch-hand-second" />
        </div>
        <span className="watch-loader-pivot" />
      </div>
      {label ? <p className="watch-loader-label">{label}</p> : null}
    </div>
  )
}
